import PlateShow from '@/common/components/base/plateShow/PlateShow';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import { InsurerInformationQuery } from '@/modules/FileDetail/queries/insurerInformation/insurerInformationQuery.type.ts';

export default (data: InsurerInformationQuery): DetailCardItemData[] => {
  return [
    {
      type: 'default',
      keyName: 'نام',
      value: `${data.first_name} ${data.last_name}`,
    },
    {
      type: 'tel',
      keyName: 'تلفن همراه',
      value: data?.phone_number,
      telephone: data?.phone_number,
    },
    {
      type: 'default',
      keyName: 'بیمه گر',
      value: data.insurance ? `بیمه ${data.insurance.fa_const}` : '',
    },
    {
      type: 'default',
      keyName: 'نوع وسیله‌نقلیه',
      value: data.vehicle_type?.fa_const,
    },
    {
      type: 'default',
      keyName: 'سیستم و تیپ خودرو ',
      value: data.vehicle_model,
    },
    {
      type: 'default',
      keyName: 'طرح پلاک',
      value: data.vehicle_plate_design?.fa_const,
    },
    {
      type: 'default',
      keyName: 'پلاک',
      value: (
        <PlateShow
          plateData={{
            vehicle_plate: data?.vehicle_plate,
            vehicle_plate_bottom: data?.vehicle_plate_bottom,
            vehicle_plate_iran: data?.vehicle_plate_iran,
            vehicle_plate_left: data?.vehicle_plate_left,
            vehicle_plate_letter: data?.vehicle_plate_letter,
            vehicle_plate_right: data?.vehicle_plate_right,
            vehicle_plate_top: data?.vehicle_plate_top,
          }}
          vehicleDesign={data?.vehicle_plate_design?.const}
          vehicleType={data.vehicle_type?.const!}
        />
      ),
    },
  ];
};
